import React, { useEffect, useState } from 'react'
import IMAGES from '../../const/Image'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Space, Form } from 'antd';
import AppoinmentRequest from './AppoinmentService';
import { determineShift, DOBFormat, formattedTimeRange } from '../../utils/utils';
import { Tag } from 'antd';

function ViewAppointments() {
    const [loading, setLoading] = useState(false)
    const { id } = useParams();
    const navigate = useNavigate()
    const [appointmentDetails, setAppoinmentDetails] = useState()
    console.log(appointmentDetails, 'appoinment')

    const fetchAppointmentDetails = (id) => {
        setLoading(true);
        const getAppoinmentDetails = async () => {
            setLoading(true);
            try {
                const res = await AppoinmentRequest.appoinmentDetails({ id });
                const categoryData = res?.data?.data;
                console.log(categoryData)
                if (categoryData) {
                    setAppoinmentDetails(categoryData);
                }
            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false);
            }
        };
        if (id) getAppoinmentDetails();


    };
    useEffect(() => {
        fetchAppointmentDetails(id);
    }, [id]);

    console.log("appointment details ", appointmentDetails)

    const statusMap = {
        0: { color: "orange", text: "Pending" },
        1: { color: "blue", text: "Booking Confirmed" },
        2: { color: "red", text: "Rejected" },
        3: { color: "purple", text: "Service Started" },
        4: { color: "green", text: "Completed" },
    };

    return (
        <div>
            <Form.Item className="submit-btn">
                <Space>
                    {/* <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}> */}
                    <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} >
                        <ArrowLeftOutlined />
                    </Button>
                </Space>
            </Form.Item>
            <div className='app-heading-med'>
                <h3>Appointment Details</h3>
            </div>
            <div className='mt-5 d-flex appointment-main'>
                {/* Booking Details */}
                <div className='appointment-pera'>
                    <div className='booking-details'>
                        <h4 className='appointment-sub-head'>Booking Details</h4>
                        <div>
                            <p><span>Appointment ID:</span> {appointmentDetails?.appointmentId}</p>
                            <p>
                                <span>Status : </span>
                                {statusMap[appointmentDetails?.status]?.text || "Unknown"}
                            </p>

                            <p><span>Salon Name:</span> {appointmentDetails?.salonName}</p>
                            <p>
                                {/* <span>Service Names: </span>{appointmentDetails?.services[0]?.serviceName} */}

                                <span>Service Names: </span>

                                {appointmentDetails?.services?.map((service , index) =>(
                                    <span key = {service.serviceId}>
                                            {service.serviceName}
                                            {index < appointmentDetails?.services.length - 1 ? ' ,' : ""}
                                    </span>
                                ))}
                               
                            </p>

                            <p>
                                <span>Service Type:</span>{' '}
                                {appointmentDetails?.services?.[0]?.serviceType === 0 && 'Home'}
                                {appointmentDetails?.services?.[0]?.serviceType === 1 && 'Salon'}
                                {appointmentDetails?.services?.[0]?.serviceType === 2 && 'Both'}
                            </p>
                            <p>
                                <span>Slot Details:</span>
                                {/* <ul className=''>
                                    <li><span>Date:</span> {DOBFormat(appointmentDetails?.bookingDate)}</li>
                                    <li><span>Time:</span> {formattedTimeRange(appointmentDetails?.services?.[0]?.slot?.startTime)} - {formattedTimeRange(appointmentDetails?.services?.[0]?.slot?.endTime)}</li>

                                </ul> */}

                                <ul>
                                    <li><span> Date :</span>{DOBFormat(appointmentDetails?.bookingDate)}   </li>
                                    {appointmentDetails?.services?.map((service , index) =>(
                                        <li key = {index}>
                                            <span>{service.serviceName} Time : </span>
                                            {formattedTimeRange(service?.slot?.startTime)} - {formattedTimeRange(service?.slot?.endTime)}
                                        </li>
                                    )
                                    )}
                                 
                                </ul>
                            </p>

                            <p>
                                <span>Duration :</span> 
                                {
                                    appointmentDetails?.services?.map((service , index) => (
                                        <span key = {service.serviceId}>
                                            {service.serviceName} : {formattedTimeRange(service?.serviceDuration)}
                                            {index < appointmentDetails?.services.length - 1 ? ',' : ''}
                                        </span>
                                  
                                        
                                    ))
                                }
                            </p>
                            <div className='location'>
                                <img src={IMAGES.LocationIcon} className='appointment-icon' alt="" />
                                <p>{appointmentDetails?.salonAddress}</p>
                            </div>
                            <p><span>Price : </span>  ₹ {appointmentDetails?.services[0]?.servicePrice}</p>
                        </div>
                    </div>
                </div>
                
                <div className='appointment-pera salon-details'>
      
                    <h4 className='appointment-sub-head'>Salon Details</h4>
                    <div>
                        <p>
                            <span>Salon Name : </span>{appointmentDetails?.salonName}
                            <Link
                                to="/salon-details"
                                style={{ color: "#1890ff", cursor: "pointer", fontSize: "17px" }}
                            >
                                {appointmentDetails?.salon?.[0]?.salonName}
                            </Link>
                        </p>
                        <div className='location'>
                            <img src={IMAGES.LocationIcon} className='appointment-icon' alt="" />
                            <p>{appointmentDetails?.salonAddress || 'No Address Available'}</p>
                        </div>
                    </div>

                    <div className='mt-3'>
                        <h4 className='appointment-sub-head '>Customer Details</h4>
                        <div>
                            <p>
                                <img src={IMAGES.UserProfile} className='appointment-icon me-1 ' alt="" />
                                {appointmentDetails?.contactDetails?.name}
                            </p>
                            <p>
                                <img src={IMAGES.GenderIcon} className='appointment-icon me-1' alt="" />
                                {appointmentDetails?.contactDetails?.gender === 0 ? 'Male' : 'Female'}
                            </p>
                            <div className='location'>
                                <img src={IMAGES.LocationIcon} className='appointment-icon' alt="" />
                                <p>
                                    {appointmentDetails?.contactDetails?.userAddress}
                                </p>
                            </div>
                            <p>
                                <img src={IMAGES.PhoneIcon} className='appointment-icon me-1' alt="" />
                                {appointmentDetails?.contactDetails?.mobile}
                            </p>
                        </div>
                    </div>
         
                </div>
           
                <div className='appointment-pera cost-details'>
                    <h4 className='appointment-sub-head'>Cost Details</h4>
                    <div>
                        <p>
                            <div className='d-flex justify-content-between align-items-center'>
                                <span>
                                    Total Price
                                </span>
                                <span>
                                    ₹ {appointmentDetails?.costDetails?.totalPrice}
                                </span>
                            </div>
                        </p>
                        <p>
                            <div className='d-flex justify-content-between align-items-center'>
                                <span>
                                    You Saved
                                </span>
                                <span>
                                  -  ₹ {appointmentDetails?.costDetails?.youSave}
                                </span>
                            </div>
                        </p>
                        <hr />
                        <p>
                            <div className='d-flex justify-content-between align-items-center'>
                                <span>
                                    Total Cost
                                </span>
                                <span>
                                    ₹ {appointmentDetails?.costDetails?.discountedPrice}
                                </span>
                            </div>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewAppointments